import React, { useState, useEffect } from 'react'
import SafeImage from "../../components/shared/SafeImage";
import DataTable from 'react-data-table-component'
import DummyIcon from '../../assets/images/user.jpg'
import { NavLink } from 'react-router-dom'
import ModalBox from '../../components/shared/pageComponent/ModalBox'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Pagination from 'react-js-pagination'
import Axios from 'axios'
import './postDetail.css'

const Bulletins = ({ history, ...props }) => {
  const [bulletinList, setBulletinList] = useState([])
  const [totalCounts, setTotalCounts] = useState(1)
  const [activePage, setActivePage] = useState(1)
  const [singleUser, setSingleUser] = useState()
  const [postToggle, setPostToggle] = useState(false)

  // GET /api/v1/admin/bulletins resolves to `{ data: AdminBulletinRow[], meta }`
  // — reshaped inline here (rather than in api/admin.js) since this
  // component was still calling raw legacy paths and had never been
  // repointed at the new API at all.
  const fetchBulletins = async (page) => {
    props.setLoading(() => true)
    try {
      const res = await Axios.get(`api/v1/admin/bulletins?page=${page}&limit=10`)
      setBulletinList(res.data.data)
      setTotalCounts(res.data.meta.total)
    } finally {
      props.setLoading(() => false)
    }
  }

  useEffect(() => {
    fetchBulletins(activePage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage])

  useEffect(() => {
    props.setTitlePage('Post Management');
  }, []);

  const handlePageChange = async (n) => {
    setActivePage(n)
  }

  const changeStatus = async (id, currentStatus) => {
    try {
      props.setLoading(() => true)
      await Axios.patch(`api/v1/admin/bulletins/${id}`, { status: !currentStatus })
      toast('Bulletin status updated')
    } finally {
      await fetchBulletins(activePage)
    }
  }

  // No standalone bulletin-detail endpoint exists — the modal only shows
  // fields already present on the list row, so reuse it instead of an
  // extra round-trip.
  const showDetails = (row) => {
    setSingleUser(row)
    setPostToggle(true)
  }

  const hideDetails = () => {
    setPostToggle(() => false)
  }

  const columns = [
    {
      name: 'Name',
      selector: 'authorName',
      cell: (row) => (
        <div className="user-wrapper">
          {row.authorId ? (
            <NavLink className="link-wrap" to={`/user-detail/${row.authorId}`}>
              <SafeImage height="33" width="33" alt={row.authorName} src={row.authorAvatarUrl || DummyIcon} />
              <span className="user-detail">
                <span className="name">{row.authorName}</span>
              </span>
            </NavLink>
          ) : (
            <span className="name">{row.authorName || 'N/A'}</span>
          )}
        </div>
      )
    },
    { name: 'Bulletin Title', selector: 'title' },
    { name: 'Description', selector: 'description' },
    {
      name: 'Talent Type',
      selector: '',
      cell: (row) => (
        <div className="user-wrapper last-item">
          {row.roles.map((title, index, arr) => (
            <span key={title}>{title}{index === arr.length - 1 ? '' : ', '}</span>
          ))}
        </div>
      )
    },
    {
      name: 'No. of Response',
      selector: '',
      center: true,
      cell: (row) => <div className="user-wrapper">{row.responseCount || 'N/A'}</div>
    },
    {
      name: 'Status',
      selector: '',
      center: true,
      cell: (row) =>
        row.status === true ? (
          <div>
            <span className="active-label">Active</span>
          </div>
        ) : (
          <div>
            <span className="inactive">Inactive</span>
          </div>
        )
    },
    {
      selector: 'action',
      cell: (row) => (
        <div>
          <div className="action-wrap">
            <div id={row.id} className="child-wrap">
              {row.status === true ? (
                <div className="activeInactive">
                  <span className="item padding" onClick={() => showDetails(row)}>
                    View Details
                  </span>
                  <span className="item inactive padd" onClick={() => changeStatus(row.id, row.status)}>
                    Inactive
                  </span>
                </div>
              ) : (
                <div className="activeInactive">
                  <span className="item padding" onClick={() => showDetails(row)}>
                    View Details
                  </span>
                  <span className="item active-label padd" onClick={() => changeStatus(row.id, row.status)}>
                    Active
                  </span>
                </div>
              )}
            </div>
            <span className="dots-btn">dots</span>
          </div>
        </div>
      )
    }
  ]

  return (
    <>
      <div className="data-search-bar">
        <h3>Bulletin Board</h3>
        <ModalBox className="modal-right" isOpen={postToggle} withHeader={true} ModalTitle="Post Details" toggle={hideDetails}>
          {singleUser && (
            <div>
              <span className="post-posted-by">Posted By</span>
              <div className="post-wrapper">
                <div className="post-user-wrapper">
                  {singleUser.authorId ? (
                    <NavLink className="post-link-wrap" to={`/user-detail/${singleUser.authorId}`}>
                      <SafeImage height="33" width="33" alt={singleUser.authorName} src={singleUser.authorAvatarUrl || DummyIcon} />
                      <span className="post-user-detail">
                        <span className="post-name">{singleUser.authorName}</span>
                      </span>
                    </NavLink>
                  ) : (
                    <span className="post-name">{singleUser.authorName || 'N/A'}</span>
                  )}
                  {singleUser.status === true ? <span className="item active-label">Active</span> : <span className="item inactive">Inactive</span>}
                </div>
              </div>
              <p className="post-title">{singleUser.title}</p>
              {singleUser.roles.map((title) => (
                <span key={title} className="post-talent-type">
                  {title}
                </span>
              ))}
              <p className="post-description">{singleUser.description}</p>
              <p className="post-response">No of Response</p>
              {singleUser.responseCount}
            </div>
          )}
        </ModalBox>
      </div>
      <DataTable columns={columns} className="custom-table user-table" data={bulletinList} />
      {totalCounts > 10 && (
        <Pagination
          activePage={activePage}
          itemsCountPerPage={10}
          totalItemsCount={totalCounts}
          pageRangeDisplayed={5}
          onChange={(num) => handlePageChange(num)}
        />
      )}
    </>
  )
}

export default Bulletins
